module.exports = __webpack_public_path__ + "static/MasterCard-Black-4204c7098517c25f2cb7fa4d8615b4e0.svg";